export enum PlannerState {
  GOALS = 'goals',
  INVESTMENT_ALLOCATION = 'investment_allocation',
  PORTFOLIO_SUMMARY = 'portfolio_summary',
}

export enum TermType {
  SHORT_TERM = 'Short Term',
  MEDIUM_TERM = 'Medium Term',
  LONG_TERM = 'Long Term',
}

export enum GoalType {
  ONE_TIME = 'One Time',
  RECURRING = 'Recurring',
}
